<template>
          <div class="row">
            <div class="col-12 mb-4">
              <SoftButton @click="goBack()" type="button" color="primary"> 
                <i
                class="fas fa-arrow-left text-sm ms-1"
                aria-hidden="true"
                ></i> &nbsp;&nbsp; Back to Menu
              </SoftButton>
            </div>
            <div class="col-12">
              <div class="card mb-4" style="padding: 15px;">
                <div style="display: flex; justify-content: flex-start; align-items: center; ">
                  <div class="movil" style="min-width: 310px; display: flex; align-items: center; gap: 5px;">
                    <b>Team</b>
                    <Multiselect 
                      style="border-radius: 0.5rem; "
                      @change="sendFilter()"
                      v-model="doc_collections.value"
                      v-bind="doc_collections"
                      placeholder="Select a team"
                    ></Multiselect>
                  </div>
                </div>
              </div>
            </div>
            <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> {{ responseMessage }} </strong>
            </soft-alert>
            <soft-alert v-show="docCorrect === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
              <strong>Document uploaded correctly</strong> It may take a few minutes for the AI to process the document, please be patient.
            </soft-alert>
            <soft-alert v-show="docNotCorrect === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
              <strong>There was an error</strong>.
            </soft-alert>
            <soft-alert v-show="noDocs === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
              <strong>There are no documents registered for this team</strong>.
            </soft-alert>
            <soft-alert v-show="docBeingUploaded === true" color="warning" icon="ni ni-dislike-2 ni-lg" dismissible>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> &nbsp;
              <strong>Document is being uploaded, please be patient and do not upload any other document in the mean time.</strong>
            </soft-alert>
            <div v-if="noData === true">
              <div v-show="docBeingUploaded === false" class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <place-holder-card style="height: 290px" data-bs-toggle="modal" data-bs-target="#uploadDoc" @click="newFile()"
                  :title="{ text: 'New file', variant: 'h5' }"
                />
              </div>
            </div>
            <div v-else class="row">
              <div v-show="docBeingUploaded === false" class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <place-holder-card style="height: 290px" data-bs-toggle="modal" data-bs-target="#uploadDoc" @click="newFile()"
                  :title="{ text: 'New file', variant: 'h5' }" 
                />
              </div>
              <div v-for="(row, i) in dataDocs" v-bind:key="i" class="col-xl-6 col-lg-6 col-md-6 mb-4">
                <div class="card" style="padding: 15px; height: 290px;">
                  <div style="display: flex; gap: 15px; justify-content: flex-start;">
                    
                    <img style="cursor: pointer; filter: opacity(0.5); transform: rotate(90deg); font-size: 15px; position: absolute; top: 10px; right: 10px;" 
                    width="15" height="15" src="https://img.icons8.com/ios-glyphs/30/ellipsis.png" alt="ellipsis"
                    @click="deleteDoc(row.token, row.title, row.collections[0])" data-bs-toggle="modal" data-bs-target="#deleteDoc"/>
                      
                    <a style="box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
                        display: contents;"
                        title="Open document on new window"
                        target="blank_" :href="'https://emailai.humantrends.io:12056/media/uploads/'+ row.url">
                      <img style="
                        width: 40%;
                        height: 260px;
                        object-fit: contain;
                        border-radius: 10px;
                        background-color: rgb(238, 237, 237);" 
                        :src="'https://emailai.humantrends.io:12056/media/uploads/'+ row.image" />
                        
                    </a>
                    
                    <div style="display: grid; align-items: start; width: 100%;">
                      <div style="max-height: 60px;
                        word-break: break-word;
                        line-break: auto;
                        overflow: hidden; margin-right: 10px;">
                        <h5 :title="row.title" style="text-overflow: ellipsis;">{{ row.title }}</h5>
                      </div>
                      <div class="mb-2 text-sm" style="max-height: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;">
                        <p :title="row.description">
                          {{ row.description }}
                        </p>
                      </div>
                      

                      <div style="word-break: break-word;
                        line-break: auto;
                        overflow: hidden;
                        max-height: 55px;">
                        <span class="pills" v-for="team in row.collections" v-bind:key="team" style="padding: 1px 10px;
                          background-color: #cb0fc9;
                          color: white;
                          font-weight: bold;
                          font-size: 12px;
                          border-radius: 20px; margin-right: 5px;">{{ team }}</span>
                      </div>

                      <div style="word-break: break-word;
                        line-break: auto;
                        position: relative;
                        bottom: 0px;">
                        <span class="pills" style="padding: 1px 10px;
                          background-color: #eaeaea;
                          color: #9E9E9E;
                          font-weight: bold;
                          font-size: 8px; 
                          border-radius: 20px; margin-right: 5px;">{{ row.author }}</span> 
                        <span class="pills" style="padding: 1px 10px;
                          background-color: #eaeaea;
                          color: #9E9E9E;
                          font-weight: bold;
                          font-size: 8px;
                          border-radius: 20px; margin-right: 5px;">{{ formatDate(row.date) }}</span>
                      </div>

                      <div v-if="loader < 100" v-show="row.processing === true" class="tilting" style="width: 100%;">
                        <progress style="width: inherit; height: 15px;" :value="loader" max="100"></progress>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          
          <!-- Modal Upload outlook-->
          <div class="modal fade" id="uploadDoc" data-bs-backdrop="static" tabindex="-1" aria-labelledby="uploadDocModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="documentModal">Upload new document</h5>
                  
                </div>
                <div class="modal-body">
                  <span style="color: red;" v-show="disableButton === true">Upload module is disabled during documents's processing<br /></span>
                  
                  <form enctype="multipart/form-data">
                    <label>Document's title</label>
                    <input
                      id="title"
                      type="text"
                      class="form-control"
                      name="titleDoc"
                      v-model="titleDoc"
                      placeholder="Document's title"
                      isRequired="required"
                    />
                    <br />
                    <label>Document's description</label>
                    <input
                      id="description"
                      type="text"
                      class="form-control"
                      name="description"
                      v-model="descriptionDoc"
                      placeholder="Document's description"
                      isRequired="required"
                    />
                    <br />
                    <label>Teams</label>
                    <Multiselect
                    style="border-radius: 0.5rem; "
                      v-model="multipleSelect.value"
                      v-bind="multipleSelect" 
                      placeholder="Select at least one team"
                    ></Multiselect>
                    <br />
                    <label>Upload any PDF, Excel or Word file from your computer</label>
                    <br />
                    <div style="display: flex; align-items: baseline;">
                      <a style="display: flex;
                        align-items: center;" class="btn" onclick="document.getElementById('pdfFile').click()">
                        <i class="ni ni-folder-17"></i>&nbsp;&nbsp;Select file
                      </a>
                      <span>&nbsp;&nbsp;{{ file }}</span>
                    </div>
                    <input style="display: none;" @change="uploadPDF" type="file" id="pdfFile" />
                  </form>
                </div>
                <div class="modal-footer">
                  <SoftButton id="closePostDoc" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton v-if="disableButton === false" @click="postDoc()">Save changes</SoftButton>
                  <SoftButton style="opacity: 0.5;" v-else>Save changes</SoftButton>
                </div>
              </div>

              <soft-alert v-show="noBBDDselected === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Select at least one team</strong>
              </soft-alert>
              <soft-alert v-show="noTitle === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Title cannot be empty</strong>
              </soft-alert>
              <soft-alert v-show="noDescription === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Description cannot be empty</strong>
              </soft-alert>
              <soft-alert v-show="noPdf === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>File cannot be empty</strong>
              </soft-alert>
            </div>
          </div>

          <div class="modal fade" id="deleteDoc" data-bs-backdrop="static" tabindex="-1" aria-labelledby="deleteDocModal" aria-hidden="true">
            <div class="modal-dialog modal-md">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="deleteModal">Delete document</h5>
                  
                </div>
                <div class="modal-body">
                  You are about to delete <b>{{ deleteTitle }}</b>, do yo want to proceed?
                </div>
                <div class="modal-footer">
                  <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton color="danger" @click="deleteDoc4real()" data-bs-dismiss="modal">Delete</SoftButton>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
  import SoftButton from '../../components/SoftButton.vue';
  import SoftAlert from "@/components/SoftAlert.vue";
  import HTFetch from "../../llamadas/HTFetch"
  import PlaceHolderCard from "../../examples/Cards/PlaceHolderCard.vue";
  import Multiselect from '@vueform/multiselect'

  export default {
    name: "documents",

    props: {
      datos: {
        type: Object,
        required: true,
      },

      colecciones: {
        type: String,
        required: true,
      }
    },

    watch: {
      datos() {
        
      },

      colecciones() {
      }
      
    },
    
    components: {
      SoftButton,
      SoftAlert,
      Multiselect,
      PlaceHolderCard
    },

    data() {
      return {
        responseMessage: "",
        showResponseMessage: false,
        intervalo: null,
        actualDate: new Date(),
        dataDocs: [],
        showMenu: false,
        llamada: new HTFetch(),
        title: "sdfsdfsdfsdf",
        description: "fsdfsdfsdfsdfsdfgdfgfdsdf dgffdgfdgfdgdfg dfg dfg dfgdfgdfgfdggdfgdfg dfgdfg dfgdfgdfg d gdfg",
        titleDoc: "",
        descriptionDoc: "",
        multipleSelect: {
          mode: 'tags',
          value: [],
          closeOnSelect: false,
          options: [
            { value: 'batman', label: 'Batman' },
            { value: 'robin', label: 'Robin' },
            { value: 'joker', label: 'Joker' },
          ]
        },
        doc_collections: {
          value: [],
          closeOnSelect: true,
          options: [],
          canClear: false,
          canDeselect: false
        },
        body: new FormData(),
        pdf: null,
        file: null,
        noData: true,
        docCorrect: false,
        docNotCorrect: false,
        noDocs: false,
        docBeingUploaded: false,
        deleteToken: "",
        deleteTitle: "",
        collectionSelected: "",
        disableButton: false,
        collectionDocDeleted: "",
        noBBDDselected: false,
        noTitle: false,
        noDescription: false,
        noPdf: false
      };
    },

    mounted() {
      this.userInformation()
      this.init()
    },

    computed: {
      loader() {
        let output

        for (let i = 0; i < this.dataDocs.length; i++) {
          if (this.dataDocs[i].processing === true) {
            
            var currentDate = this.actualDate
            var currentUTCDate = new Date(currentDate.toUTCString());

            // Parse the provided date string
            var providedDate = new Date(this.dataDocs[i].date);

            // Calculate the difference in milliseconds
            var timeDiff = currentUTCDate.getTime() - providedDate.getTime();

            // Calculate the difference in minutes
            var minutesDiff = timeDiff / (1000 * 60);

            output = (minutesDiff*100)/3

            if (output === 3) {
              clearInterval(this.intervalo)
            }
          }
        }

        return output
      }
    },

    methods: {

      init() {
        this.intervalo = setInterval(()=>{
          this.actualDate = new Date()
        }, 500)

        this.intervalo
      },

      userInformation() {
        this.llamada.userInfo(this.userInfoRsp.bind(this))
      },

      userInfoRsp(rsp) {
        if (rsp.status === 401) {
          
          this.llamada.userInfo(this.userInfoRsp.bind(this))
          return
        }
        
        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.document_collections).length; i++) {
          collecciones.push({
            "label": Object.keys(rsp.data.document_collections)[i],
            "value": Object.values(rsp.data.document_collections)[i]
          })
        }

        localStorage.docCollections = JSON.stringify(collecciones)

        this.multipleSelect.options = collecciones
        this.doc_collections.options = collecciones
        this.doc_collections.value = collecciones[0].value

        localStorage.userId = rsp.data.token

      },

      sendFilter() {
        setTimeout(() => {
          this.getDocs()
        }, 500)
      },

      getDocs() {
        this.llamada.getDocs(this.doc_collections.value, this.getDocsRsp.bind(this))
      },

      getDocsRsp(rsp) {
        this.dataDocs = rsp.data

        if (this.dataDocs.length !== 0) {
          this.noData = false

          for (let i = 0; i < this.dataDocs.length; i++) {
            var currentDate = new Date();
            var currentUTCDate = new Date(currentDate.toUTCString());

            // Parse the provided date string
            var providedDate = new Date(this.dataDocs[i].date);

            // Calculate the difference in milliseconds
            var timeDiff = currentUTCDate.getTime() - providedDate.getTime();

            // Calculate the difference in minutes
            var minutesDiff = timeDiff / (1000 * 60);

            // Check if five minutes have passed
            if (minutesDiff >= 3) {
              // Five minutes have passed
              // Perform your desired action here
              this.dataDocs[i].processing = false
            } else {
              // Five minutes have not passed
              this.dataDocs[i].processing = true
              this.disableButton = true

              setTimeout(() => {
                this.disableButton = false
                
              }, 1000*180)
            } 
          }
        } else {
          this.noData = true
          /*this.noDocs = true

          setTimeout(() => {
            this.noDocs = false
          }, 2000)*/
        }
        
        if (rsp.status === 402) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.Message.replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        }
      },

      uploadPDF(event) {
        const file = event.target.files[0];
        this.file = event.target.files[0].name
        function readFile(imagen, handler) {
            var reader = new FileReader();
            
            reader.onload = () => {
                handler(reader.result);
            }
            reader.onerror = function () {
                alert('There was an error reading the file!');
            }
            reader.readAsDataURL(imagen);
        }

        readFile(file, function(s) {
          this.pdf = s.split('base64,')[1]
          
        }.bind(this))
      },

      postDoc() {
        if (this.multipleSelect.value.length === 0) {

          this.noBBDDselected = true

          setTimeout(() => {
            this.noBBDDselected = false
          }, 2000)

          return
        }
        
        if (this.titleDoc.length === 0) {
          this.noTitle = true

          setTimeout(() => {
            this.noTitle = false
          }, 2000)

          return
        }

        if (this.descriptionDoc.length === 0) {
          this.noDescription = true

          setTimeout(() => {
            this.noDescription = false
          }, 2000)

          return
        }

        if (this.pdf === null) {
          this.noPdf = true

          setTimeout(() => {
            this.noPdf = false
          }, 2000)

          return
        }

        let body = {
          "title": this.titleDoc,
          "description": this.descriptionDoc,
          "collection": this.multipleSelect.value,
          "pdf_file": this.pdf
        }

        /*let data = new FormData()

        data.append("title", this.titleDoc)
        data.append("description", this.descriptionDoc)
        data.append("collection", this.multipleSelect.value)
        data.append("pdf_file", this.pdf)*/
        
        this.llamada.postDoc(body, this.postDocRsp.bind(this))

        document.getElementById('closePostDoc').click()

        this.docBeingUploaded = true

        //mando el evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-doc",
            user_id: localStorage.userId
          });
        }
      },

      postDocRsp(rsp) {
        this.file = ""
        if (rsp.status === 400) {
          if ('message' in rsp.data) {
            this.showResponseMessage = true
            this.responseMessage = rsp.data.message
            this.docBeingUploaded = false

            setTimeout(() => {
              this.showResponseMessage = false
            }, 5000)
            return
          }
          if ('pdf_file' in rsp.data) {
            this.showResponseMessage = true
            this.responseMessage = 'File ' +rsp.data.pdf_file
            this.docBeingUploaded = false

            setTimeout(() => {
              this.showResponseMessage = false
            }, 5000)
            return
          }
          if ('description' in rsp.data) {
            this.showResponseMessage = true
            this.responseMessage = 'Description ' + rsp.data.description
            this.docBeingUploaded = false

            setTimeout(() => {
              this.showResponseMessage = false
            }, 5000)
            return
          }
          if ('title' in rsp.data) {
            this.showResponseMessage = true
            this.responseMessage = 'Title ' + rsp.data.title
            this.docBeingUploaded = false

            setTimeout(() => {
              this.showResponseMessage = false
            }, 5000)
            return
          }
        } else {
          if ('message' in rsp.data) {
            if (rsp.data.message === "Document is being processed") {
              this.docCorrect = true
              this.docBeingUploaded = false
              setTimeout(() => {
                this.docCorrect = false
              }, 15000)

              this.getDocs()

              this.titleDoc = ""
              this.descriptionDoc = ""
              this.multipleSelect.value = []
              this.pdf = ""

              return
          
            } else {
              this.docNotCorrect = true

              setTimeout(() => {
                this.docNotCorrect = false
              }, 2000)
            }
          } else {
            this.docBeingUploaded = false
            this.docNotCorrect = true

            setTimeout(() => {
              this.docNotCorrect = false
            }, 2000)
          }
        }
        

        if (typeof rsp === 'undefined') {
          this.docNotCorrect = true
          this.docBeingUploaded = false

          setTimeout(() => {
            this.docNotCorrect = false
          }, 2000)

          return
        }
        
      },

      deleteDoc(token, title, collection) {
        this.deleteTitle = title
        this.deleteToken = token
        this.collectionDocDeleted = collection
      },

      deleteDoc4real() {
        let body = {
          "token": this.deleteToken
        }

        this.llamada.deleteDoc(body, this.deleteDocRsp.bind(this))
      },

      deleteDocRsp(rsp) {
        console.log(rsp)
        this.getDocs()
      },

      goBack() {
        console.log('el error de volver a Database está aqui')
        this.$emit('go-back')
      },

      newFile() {
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "new-doc",
            user_id: localStorage.userId
          });
        }
      },

      formatDate(date) {
        const fecha = new Date(date);

        const year = fecha.getFullYear();
        const month = ("0" + (fecha.getMonth() + 1)).slice(-2);
        const day = ("0" + fecha.getDate()).slice(-2);
        const hours = ("0" + fecha.getHours()).slice(-2);
        const minutes = ("0" + fecha.getMinutes()).slice(-2);
        const seconds = ("0" + fecha.getSeconds()).slice(-2);

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
    
  };
</script>

<style scoped>
    .tilting {
        -webkit-animation: fadein 2s infinite;
        animation: fadein 2s infinite;
    }

    @keyframes fadein {
        0% { opacity: 0.25;}
        100% { opacity: 1;}
    }

    @media (max-width: 425px) {
      .movil {
        flex-direction: column;
        width: fit-content !important;
      }
      
    }
</style>
